// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-watermark-config {
   display: flex;
   flex-direction: column;
   flex: 1;
   overflow: hidden;
}

.list {
   margin: 20px 0 10px 0;
   padding-left: 10px;
}

#main {
   border: 2px solid #dedede;
   width: 350px;
   height: 35px;
   border-radius: 20px;
   display: -webkit-flex; /* Safari */ /* Safari 6.1+ */
   display: flex;
   flex-flow: row-reverse wrap;
}

.upload {
   width: 100px;
}

.upload-input {
   text-align: center;
}

.my-mat-hint {
   line-height: 1.2em;
   transform: translateY(10px);
   font-size: 75%;
}

.watermark-form {
   min-width: 150px;
   max-width: 250px;
   width: 100%;
}

mat-form-field {
   width: 100%
}

.error {
   font-size: 11px;
   margin-left: 145px;
}

.container {
   display: flex;
   flex-direction: row;
   margin-left: 25px;
}

.form-container {
   width: 300px;
}

.preview {
   flex: 2;
   min-width: 1px;
   min-height: 0;
}

.row {
   padding: 4px 0;
}

.padding-bottom {
   padding-bottom: 16px;
}

.radio-group {
   display: flex;
   flex-direction: column;
   align-items: flex-start;
}

.radio-button {
   margin: 5px;
}

.canvas-container {
   display: flex;
   flex-direction: column;
   align-items: flex-start;
}

.mat-raised-button {
   line-height: 30px;
}

.label {
   margin-bottom: 8px;
}

canvas {
   background-color: white;
   border: 1px solid rgb(161,165,166);
} 

.content {
   margin-left: 50px;
}

.mat-form-field-underline .ng-tns-c128-67 .ng-star-inserted{
   margin-bottom: 0.34375em;
}

.header-padding {
   padding-left: 26px;
}

::ng-deep .mat-select-value {
   display: table-cell;
   width: 100%;
   overflow: hidden;
   text-overflow: ellipsis;
   white-space: nowrap;
   margin-bottom: 20px;
}

::ng-deep .mat-form-field-label-wrapper {
   font-size: 14px;
   position: absolute;
   left: 0;
   box-sizing: content-box;
   width: 100%;
   height: 100%;
   overflow: hidden;
   pointer-events: none;
}

button:disabled{
   opacity: 0.3;
 }`, "",{"version":3,"sources":["webpack://./src/app/admin/watermark/watermark.component.css"],"names":[],"mappings":"AAAA;GACG,aAAa;GACb,sBAAsB;GACtB,OAAO;GACP,gBAAgB;AACnB;;AAEA;GACG,qBAAqB;GACrB,kBAAkB;AACrB;;AAEA;GACG,yBAAyB;GACzB,YAAY;GACZ,YAAY;GACZ,mBAAmB;GACnB,qBAAqB,EAAE,WAAW,EACG,gBAAgB;GACrD,aAAa;GACb,2BAA2B;AAC9B;;AAEA;GACG,YAAY;AACf;;AAEA;GACG,kBAAkB;AACrB;;AAEA;GACG,kBAAkB;GAClB,2BAA2B;GAC3B,cAAc;AACjB;;AAEA;GACG,gBAAgB;GAChB,gBAAgB;GAChB,WAAW;AACd;;AAEA;GACG;AACH;;AAEA;GACG,eAAe;GACf,kBAAkB;AACrB;;AAEA;GACG,aAAa;GACb,mBAAmB;GACnB,iBAAiB;AACpB;;AAEA;GACG,YAAY;AACf;;AAEA;GACG,OAAO;GACP,cAAc;GACd,aAAa;AAChB;;AAEA;GACG,cAAc;AACjB;;AAEA;GACG,oBAAoB;AACvB;;AAEA;GACG,aAAa;GACb,sBAAsB;GACtB,uBAAuB;AAC1B;;AAEA;GACG,WAAW;AACd;;AAEA;GACG,aAAa;GACb,sBAAsB;GACtB,uBAAuB;AAC1B;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,kBAAkB;AACrB;;AAEA;GACG,uBAAuB;GACvB,kCAAkC;AACrC;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,wBAAwB;AAC3B;;AAEA;GACG,kBAAkB;AACrB;;AAEA;GACG,mBAAmB;GACnB,WAAW;GACX,gBAAgB;GAChB,uBAAuB;GACvB,mBAAmB;GACnB,mBAAmB;AACtB;;AAEA;GACG,eAAe;GACf,kBAAkB;GAClB,OAAO;GACP,uBAAuB;GACvB,WAAW;GACX,YAAY;GACZ,gBAAgB;GAChB,oBAAoB;AACvB;;AAEA;GACG,YAAY;CACd","sourcesContent":[".app-watermark-config {\n   display: flex;\n   flex-direction: column;\n   flex: 1;\n   overflow: hidden;\n}\n\n.list {\n   margin: 20px 0 10px 0;\n   padding-left: 10px;\n}\n\n#main {\n   border: 2px solid #dedede;\n   width: 350px;\n   height: 35px;\n   border-radius: 20px;\n   display: -webkit-flex; /* Safari */\n   -webkit-flex-flow: row-reverse wrap; /* Safari 6.1+ */\n   display: flex;\n   flex-flow: row-reverse wrap;\n}\n\n.upload {\n   width: 100px;\n}\n\n.upload-input {\n   text-align: center;\n}\n\n.my-mat-hint {\n   line-height: 1.2em;\n   transform: translateY(10px);\n   font-size: 75%;\n}\n\n.watermark-form {\n   min-width: 150px;\n   max-width: 250px;\n   width: 100%;\n}\n\nmat-form-field {\n   width: 100%\n}\n\n.error {\n   font-size: 11px;\n   margin-left: 145px;\n}\n\n.container {\n   display: flex;\n   flex-direction: row;\n   margin-left: 25px;\n}\n\n.form-container {\n   width: 300px;\n}\n\n.preview {\n   flex: 2;\n   min-width: 1px;\n   min-height: 0;\n}\n\n.row {\n   padding: 4px 0;\n}\n\n.padding-bottom {\n   padding-bottom: 16px;\n}\n\n.radio-group {\n   display: flex;\n   flex-direction: column;\n   align-items: flex-start;\n}\n\n.radio-button {\n   margin: 5px;\n}\n\n.canvas-container {\n   display: flex;\n   flex-direction: column;\n   align-items: flex-start;\n}\n\n.mat-raised-button {\n   line-height: 30px;\n}\n\n.label {\n   margin-bottom: 8px;\n}\n\ncanvas {\n   background-color: white;\n   border: 1px solid rgb(161,165,166);\n} \n\n.content {\n   margin-left: 50px;\n}\n\n.mat-form-field-underline .ng-tns-c128-67 .ng-star-inserted{\n   margin-bottom: 0.34375em;\n}\n\n.header-padding {\n   padding-left: 26px;\n}\n\n::ng-deep .mat-select-value {\n   display: table-cell;\n   width: 100%;\n   overflow: hidden;\n   text-overflow: ellipsis;\n   white-space: nowrap;\n   margin-bottom: 20px;\n}\n\n::ng-deep .mat-form-field-label-wrapper {\n   font-size: 14px;\n   position: absolute;\n   left: 0;\n   box-sizing: content-box;\n   width: 100%;\n   height: 100%;\n   overflow: hidden;\n   pointer-events: none;\n}\n\nbutton:disabled{\n   opacity: 0.3;\n }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
